module.exports = __webpack_public_path__ + "img/first-steps-1-min.f68f9675.png";